import { GET_USER_SETTINGS } from "helpers/constants";

export const UserSettings = (userSettings = null, action) => {
	switch (action.type) {
		case GET_USER_SETTINGS:
			return action.payload;

		default:
			return userSettings;
	}
};
